import type Mdast from "mdast";
import { fromMarkdown } from "mdast-util-from-markdown";
import { gfmFromMarkdown, gfmToMarkdown } from "mdast-util-gfm";
import { mathFromMarkdown, mathToMarkdown } from "mdast-util-math";
import { mdxJsxFromMarkdown, mdxJsxToMarkdown } from "mdast-util-mdx-jsx";
import { toMarkdown } from "mdast-util-to-markdown";
import { gfm } from "micromark-extension-gfm";
import { math } from "micromark-extension-math";
import { mdxJsx } from "micromark-extension-mdx-jsx";
import * as op from "@/shared/operation";
import { inlineActionFromMarkdown, inlineActionToMarkdown } from "./mdast-extensions/inline-action";
import {
  interruptedMarkerFromMarkdown,
  interruptedMarkerToMarkdown,
} from "./mdast-extensions/interrupted";
import { keyFromMarkdown } from "./mdast-extensions/key";

/**
 * Convert a Markdown string to a Markdown tree
 * @param content - The Markdown string to convert
 * @returns The Markdown tree
 */
export const markdownToTree = (content: string) =>
  op.attempt(() =>
    fromMarkdown(content, "utf-8", {
      extensions: [gfm(), math(), mdxJsx()],
      mdastExtensions: [
        interruptedMarkerFromMarkdown,
        inlineActionFromMarkdown,
        mdxJsxFromMarkdown(),
        gfmFromMarkdown(),
        mathFromMarkdown(),
        keyFromMarkdown,
      ],
    }),
  );

/**
 * Convert a Markdown tree to a Markdown string
 * @param tree - The Markdown tree to convert
 * @returns The Markdown string
 */
export const markdownFromTree = (tree: Mdast.Root) =>
  op.attempt(() =>
    toMarkdown(tree, {
      extensions: [
        interruptedMarkerToMarkdown,
        inlineActionToMarkdown,
        gfmToMarkdown(),
        mathToMarkdown(),
        mdxJsxToMarkdown(),
      ],
    }),
  );
